<template>
  <div class="list">
    <slot />
  </div>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { ContainerMixin } from "vue-slicksort";
// https://vuejsexamples.com/a-set-of-vue-mixins-to-turn-any-list-into-an-animated-sortable-list/

@Component({
  mixins: [ContainerMixin]
})
export default class CodeListing extends Vue {
}
</script>

<style>
</style>
